const config = {
  TILE_WIDTH: 36,
  TILE_HEIGHT: 18,
  LOCATION_DIMENSION: [10, 10], //10 xLength, 10 yLength,
  OFFSET_HEIGHT: 160,
  TOTAL_FRAME_SPRITESHEET: 16
}

export default config;